import { defineMessages } from 'react-intl';

export default defineMessages({
    summaryVehicles: {
        id: 'ml.quoteandbind.pa.policySummary.Vehicles',
        defaultMessage: 'Vehicles'
    },
    summaryVehicleYear: {
        id: 'ml.quoteandbind.pa.policySummary.vehicle.YEAR',
        defaultMessage: 'YEAR'
    },
    summaryVehicleMake: {
        id: 'ml.quoteandbind.pa.policySummary.vehicle.MAKE',
        defaultMessage: 'MAKE'
    },
    summaryVehicleModel: {
        id: 'ml.quoteandbind.pa.policySummary.vehicle.MODEL',
        defaultMessage: 'MODEL'
    },
    summaryVehicleTrim: {
        id: 'ml.quoteandbind.pa.policySummary.vehicle.TRIM',
        defaultMessage: 'TRIM'
    },
    summaryVehicleVin: {
        id: 'ml.quoteandbind.pa.policySummary.vehicle.VIN',
        defaultMessage: 'VIN'
    },
    summaryCoverages: {
        id: 'ml.quoteandbind.pa.policySummary.Coverages',
        defaultMessage: 'Coverages'
    },
    summaryVehicleCoverages: {
        id: 'ml.quoteandbind.pa.policySummary.Vehicle coverages',
        defaultMessage: 'Vehicle coverages'
    },
    summaryEditVehicles: {
        id: 'ml.quoteandbind.pa.policySummary.Edit Vehicles',
        defaultMessage: 'Edit Vehicles'
    }
});
